import { render } from "./Index.vue?vue&type=template&id=3f26c2cc&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=3f26c2cc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-3f26c2cc"

export default script